import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { GridCol } from 'dibs-elements/exports/Grid';
import { useIntl, defineMessages } from 'dibs-react-intl';
import HpRespModuleItemTile from '../HpRespModuleItemTile/HpRespModuleItemTile';

import styles from './HpRespEditorialModuleItem.scss';

const messages = defineMessages({
    introspective: {
        id: 'homepage.modules.HpRespEditorialModule.introspective',
        defaultMessage: 'Introspective Magazine',
    },
    study: {
        id: 'homepage.modules.HpRespEditorialModule.study',
        defaultMessage: 'The Study',
    },
});

import { HpRespEditorialModuleItem_item } from './__generated__/HpRespEditorialModuleItem_item.graphql';

type Props = {
    item: HpRespEditorialModuleItem_item;
    index: number;
    onClick: () => void;
    useLazyLoadImages: boolean;
};

const HpRespEditorialModuleItem: FC<Props> = ({
    item,
    index,
    onClick = () => {},
    useLazyLoadImages,
}) => {
    const intl = useIntl();
    const message = intl.formatMessage(messages[index === 0 ? 'introspective' : 'study']);

    const { linkData, cta, description, imageUrl, imageHeight, imageWidth } = item;

    return (
        <GridCol tabletLandscape={6}>
            <div className={styles.itemWrapper}>
                <HpRespModuleItemTile
                    linkData={linkData}
                    dataTn={`editorial-link-${index}`}
                    onClick={onClick}
                    title={message}
                    description={description}
                    cta={cta}
                    imageUrl={imageUrl}
                    imgSrcSetWidths={[400, 640, 800]}
                    imgSizes="(max-width:768px) 95vw, 50vw"
                    imageHeight={imageHeight}
                    imageWidth={imageWidth}
                    imageClass={styles.tileImage}
                    imageOverlayClass={styles.tileImageOverlay}
                    useLazyLoadImages={useLazyLoadImages}
                />
            </div>
        </GridCol>
    );
};

export default createFragmentContainer(HpRespEditorialModuleItem, {
    item: graphql`
        fragment HpRespEditorialModuleItem_item on EditorialItem {
            description
            cta
            imageUrl
            imageWidth
            imageHeight
            linkData {
                ...HpRespModuleItemTile_linkData
            }
        }
    `,
});
